import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredConfigKeys = ["apiKey", "authDomain", "projectId", "appId"];
const hasValidFirebaseConfig = requiredConfigKeys.every((key) => {
  const value = firebaseConfig[key];
  return (
    typeof value === "string" &&
    value.trim().length > 0 &&
    !value.startsWith("your_")
  );
});

let app = null;

if (hasValidFirebaseConfig) {
  try {
    app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  } catch (error) {
    console.error("Firebase initialization failed:", error);
    app = null;
  }
} else {
  console.warn(
    "Firebase config is missing or incomplete. Voting features are disabled.",
  );
}

export const isFirebaseConfigured = Boolean(app);
export const auth = app ? getAuth(app) : null;
export const provider = new GoogleAuthProvider();
export const db = app ? getFirestore(app) : null;
